var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_vm._t("default"),(_vm.$ability.canManage(_vm.resourceClass))?_c('th',{staticClass:"action",attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t('.actions')))]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }